import React from 'react';
import { useSelector } from 'store';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Autoplay } from 'swiper';

SwiperCore.use([Autoplay]);

const TopNotice: React.FC = () => {
  const notices = useSelector(state => state.community.noticesFixed);

  const data = notices?.results ?? [];

  return (
    <div className="top-notice" style={{ marginBottom: -24 }}>
      <h3>공지사항</h3>
      <div style={{ height: 19, overflow: 'hidden' }}>
        <Swiper direction="vertical" height={19} autoplay>
          {data.map(({ id, title }) => (
            <SwiperSlide key={id} tag="p">
              <a href={`/community/notice/${id}`}>{title}</a>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
};

export default TopNotice;
